;(function () {
  'use strict';
  var host = document.querySelector('[data-drawers-host]');
  if (!host) return;

  // Step-1 fade-out is 0.3s; the panel/overlay swap happens at SWITCH_MS, and the
  // switching phase ends at SWITCH_MS * 2 (0.6s) so the [switching][active] rule
  // owns the full incoming fade-in (out 0–0.3s, in 0.3–0.6s) per Figma
  // 1451:25035 / 1451:25146 (desktop) and 1451:25043 (mobile).
  var SWITCH_MS = 300;

  // --- Registry: name → open-state element/attribute + trigger + public API ---
  // Four cross-fade participants. Two of them are NOT [data-drawers-host]
  // descendants (search renders before the host; menu lives inside <header>) and
  // menu's open-state flag lives on [data-header], not on the drawer root — the
  // registry captures each drawer's real element/attribute so the observer and
  // reconcileActive read the correct source.
  // Mobile = anything failing the theme's desktop condition (width).
  var mqDesktop  = window.matchMedia('(min-width: 1024px)');
  var headerEl   = document.querySelector('[data-header]');
  var bagRoot    = document.querySelector('[data-mini-bag]');
  var wishRoot   = document.querySelector('[data-wishlist-drawer]');
  var searchRoot = document.querySelector('[data-search-drawer]');
  var roots = {
    bag:      { el: bagRoot,    attr: 'data-mini-bag-open',        trigger: '[data-mini-bag-trigger]',        api: function () { return window.miniBag || null; } },
    wishlist: { el: wishRoot,   attr: 'data-wishlist-drawer-open', trigger: '[data-wishlist-drawer-trigger]', api: function () { return window.broraWishlistDrawer || null; } },
    search:   { el: searchRoot, attr: 'data-search-drawer-open',   trigger: '[data-search-drawer-trigger]',   api: function () { return window.broraSearchDrawer || null; } },
    menu:     { el: headerEl,   attr: 'data-menu-open',            trigger: '[data-menu-toggle]',             api: function () { return window.broraMenuDrawer || null; } }
  };
  var PARTICIPANTS = { bag: true, wishlist: true, search: true, menu: true };   // all four cross-fade

  var switchToken = 0;

  // Bag-only redundant reveal: header.js's own drawer-open MutationObserver (§5) already
  // reveals a scrolled-off header for bag, search, and wishlist directly off the same
  // [data-header] attributes. This is kept as a same-task belt-and-braces path for the bag
  // specifically (idempotent with that observer). Not snapped back on close — scroll takes over.
  var headerGroup = document.querySelector('[data-header-group]');
  function syncHeaderReveal(active) {
    if (headerGroup && active === 'bag' && headerGroup.dataset.headerSticky === 'hidden') {
      headerGroup.dataset.headerSticky = 'visible';
    }
  }

  // The switching/active signal is mirrored onto BOTH the host (read by the
  // pointer-gated desktop rules) and document.documentElement (read by the
  // mobile complement block) so it reaches search + menu, which are not
  // host descendants. The mirror is an attribute, not a transform — no
  // containing-block side-effect on position:fixed children.
  //
  // inert only — aria-hidden trips the Wrapped app's re-render observer. <header>
  // is never inerted: it is drawer chrome (menu drawer, mobile close/switch icons)
  // and inerting it would trap touch users in an open drawer.
  function setBackgroundInert(active) {
    var on = active !== 'none';
    [document.querySelector('[data-announcement-bar]'), document.querySelector('main'), document.querySelector('[data-footer]')].forEach(function (el) {
      if (el) el.toggleAttribute('inert', on);
    });
  }
  function setActive(name)  { host.setAttribute('data-drawers-active', name); document.documentElement.setAttribute('data-drawers-active', name); setBackgroundInert(name); syncHeaderReveal(name); }
  function setSwitching(v)   { host.setAttribute('data-drawers-switching', v); document.documentElement.setAttribute('data-drawers-switching', v); }

  // Reflect the four drawers' real open-state into data-drawers-active so the
  // cross-fade origin and switchTo's early-return are always correct, for EVERY
  // entry point — not just coordinator switches. Precedence search → menu →
  // wishlist → bag → none (deterministic; the drawers are mutually exclusive on
  // the non-switch path). Skipped while a switch is mid-flight (switchTo owns the
  // flag during the 0.6s window); reconciled again when the switch ends.
  function reconcileActive() {
    if (host.getAttribute('data-drawers-switching') === 'true') return;
    var active = 'none';
    ['search', 'menu', 'wishlist', 'bag'].forEach(function (name) {
      var r = roots[name];
      if (active === 'none' && r.el && r.el.getAttribute(r.attr) === 'true') active = name;
    });
    setActive(active);
  }

  // First focusable element of the incoming panel — matches each controller's own
  // open-from-closed focus target (search → its input; others → close/first
  // focusable). The four panels live in three different roots (host, theme.liquid,
  // header), so this is the documented cross-root document-scoped query.
  function focusIncoming(target) {
    var sel = {
      bag:      '[data-drawers-panel="bag"] [data-mini-bag-close]',
      wishlist: '[data-drawers-panel="wishlist"] [data-wishlist-drawer-close]',
      search:   '[data-drawers-panel="search"] [data-search-drawer-input]',
      menu:     '[data-drawers-panel="menu"] [data-menu-toggle], [data-drawers-panel="menu"] a, [data-drawers-panel="menu"] button'
    }[target];
    if (!sel) return;
    var el = document.querySelector(sel);
    if (!el || typeof el.focus !== 'function') return;
    el.focus();
  }

  // Each controller OWNS its slide/scroll-lock/focus-trap lifecycle. On a switch
  // the coordinator passes { tabSwitch: true } so they SKIP that lifecycle (panel
  // jumps on/off-screen instantly, content cross-fades) but still toggle
  // aria-hidden+inert and their open-state flag. The coordinator's ONLY ARIA/inert
  // responsibility is background isolation (setBackgroundInert, funnelled through
  // setActive): it inerts the body-level background siblings while any drawer is
  // open and never touches a drawer's own ARIA. It dispatches no events; it toggles
  // host/root state + background inert + moves focus. close() BEFORE open() so the
  // scroll-lock is never dropped. A monotonic switchToken makes a superseded
  // switch's timers no-op.
  function switchTo(target) {
    if (host.getAttribute('data-drawers-active') === target) return;
    var current = host.getAttribute('data-drawers-active');
    var token = ++switchToken;
    setSwitching('true');
    setActive(target);

    // Phase A — swap at the fade-out midpoint (instant, no slide, no scroll-lock
    // churn, no focus-trap re-init), then hand focus to the incoming panel.
    window.setTimeout(function () {
      if (token !== switchToken) return; // superseded by a newer switch
      var out = (current && roots[current]) ? roots[current].api() : null;
      if (out && typeof out.close === 'function') out.close({ tabSwitch: true });
      var inc = roots[target].api();
      if (inc && typeof inc.open === 'function') inc.open(null, { tabSwitch: true });
      focusIncoming(target); // manual focus — the controllers skipped it during tabSwitch
    }, SWITCH_MS);

    // Phase B — end the switching phase after the incoming fade-in completes,
    // then reconcile in case the open-state changed mid-switch (e.g. Escape).
    window.setTimeout(function () {
      if (token !== switchToken) return;
      setSwitching('false');
      reconcileActive();
    }, SWITCH_MS * 2);
  }

  // Desktop tab clicks come from inside EITHER panel (both host descendants).
  // stopPropagation so no document-level handler can also act on the click.
  host.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-mini-bag-tab]');
    if (!tab || !host.contains(tab)) return;
    var to = tab.getAttribute('data-mini-bag-tab'); // "bag" | "wishlist"
    if (to !== 'bag' && to !== 'wishlist') return;
    e.preventDefault();
    e.stopPropagation();
    // Mark which view is current for assistive tech. Server-rendered once and never
    // moved before this; every tab button under the host is kept in step.
    host.querySelectorAll('[data-mini-bag-tab]').forEach(function (el) {
      el.setAttribute('aria-current', String(el.getAttribute('data-mini-bag-tab') === to));
    });
    switchTo(to);
  });

  // Mobile switch-intercept — the top-nav-icon entry point. Registered on WINDOW
  // in the CAPTURE phase so it fires before every document-level handler
  // (the per-drawer trigger handlers + the ad-hoc mutual-exclusion handlers)
  // regardless of script load order (L-XF-7). It acts ONLY on a cross-drawer tap
  // (a different participant is open) — leaving open-from-nothing and
  // toggle-close to the existing per-drawer slide handlers.
  window.addEventListener('click', function (e) {
    if (mqDesktop.matches) return;                       // desktop uses the tab bar
    var target = null;
    for (var name in roots) {
      if (roots.hasOwnProperty(name) && e.target.closest(roots[name].trigger)) { target = name; break; }
    }
    if (!target) return;                                 // not a top-nav trigger
    var active = host.getAttribute('data-drawers-active');
    if (active === 'none' || active === target) return;  // open-from-nothing / toggle-close → existing slide
    // [data-menu-toggle] doubles as the close-X once any drawer is open (the hamburger
    // morphs into the X, and each drawer owns a close-on-[data-menu-toggle] listener),
    // so a tap on it here is a CLOSE, not a switch to menu. On mobile menu is a switch
    // SOURCE only — with a drawer open there is no menu icon to tap (it is the X), so
    // menu is never a switch TARGET; return and let the open drawer's own close run.
    if (target === 'menu') return;
    if (!PARTICIPANTS[active] || !PARTICIPANTS[target]) return; // (defensive — all four are participants)
    e.preventDefault();
    e.stopImmediatePropagation();                        // sole owner of a switch tap (L-XF-7)
    switchTo(target);
  }, true);                                              // CAPTURE on window — precedes every document handler

  // Keep data-drawers-active in sync with reality for all non-coordinator entry
  // points by observing each root's own single open-state attribute (always
  // written by its controller, on every path). Per-attribute filter so the
  // header's other attribute writes (sticky, per-drawer open mirrors) do not fire.
  var observer = new MutationObserver(reconcileActive);
  ['bag', 'wishlist', 'search', 'menu'].forEach(function (name) {
    var r = roots[name];
    if (r.el) observer.observe(r.el, { attributes: true, attributeFilter: [r.attr] });
  });
  reconcileActive();
})();
